import { MapPin, Phone, Mail, Clock, MessageCircle, Facebook } from "lucide-react";
import { LOGO_URL } from "@/App";
import { WHATSAPP_URL, FACEBOOK_URL } from "@/components/WhatsAppFloat";

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="border-t border-[#1F232D] bg-panel/50">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-5">
          <img
            src={LOGO_URL}
            alt="bm solutions logo"
            className="h-12 w-12 object-cover rounded-full ring-1 ring-[#262933]"
          />
          <span className="font-heading font-bold text-2xl tracking-wide uppercase">
            bm <span className="text-nitro">solutions</span>
          </span>
        </div>
        <p className="text-sm text-neutral-400 leading-relaxed max-w-xs">
          Precision ECU remapping and high-performance tuning. Custom software,
          dyno-proven results, 1-year map warranty.
        </p>
      </div>

      <div>
        <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-nitro mb-5">
          Get In Touch
        </h4>
        <ul className="flex flex-col gap-4 text-sm text-neutral-300">
          <li className="flex items-start gap-3">
            <MapPin size={16} className="text-nitro shrink-0 mt-0.5" />
            <span>
              Mobile remapping service —
              <br />
              we come to you
            </span>
          </li>
          <li className="flex items-center gap-3">
            <Phone size={16} className="text-nitro shrink-0" />
            07415 275028
          </li>
          <li className="flex items-center gap-3">
            <Mail size={16} className="text-nitro shrink-0" />
            bm.solutions2026@outlook.com
          </li>
          <li className="flex items-center gap-3">
            <MessageCircle size={16} className="text-nitro shrink-0" />
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="hover:text-nitro transition-colors duration-300"
            >
              WhatsApp us — 07415 275028
            </a>
          </li>
          <li className="flex items-center gap-3">
            <Facebook size={16} className="text-nitro shrink-0" />
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="hover:text-nitro transition-colors duration-300"
            >
              Follow us on Facebook
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-nitro mb-5">
          Opening Hours
        </h4>
        <ul className="flex flex-col gap-3 text-sm text-neutral-300">
          <li className="flex items-center gap-3">
            <Clock size={16} className="text-nitro shrink-0" />
            Mon – Fri · 08:30 – 18:00
          </li>
          <li className="flex items-center gap-3">
            <Clock size={16} className="text-nitro shrink-0" />
            Saturday · 09:00 – 16:00
          </li>
          <li className="flex items-center gap-3">
            <Clock size={16} className="text-neutral-600 shrink-0" />
            <span className="text-neutral-500">Sunday · Closed</span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#1F232D]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          © {new Date().getFullYear()} bm solutions. All rights reserved.
        </p>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          Precision. Power. <span className="text-nitro">Proven.</span>
        </p>
      </div>
    </div>
  </footer>
);
